import { render, staticRenderFns } from "./CompLangaugeSelector.vue?vue&type=template&id=db1a1586&"
import script from "./CompLangaugeSelector.vue?vue&type=script&lang=js&"
export * from "./CompLangaugeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports